<script setup>
defineProps({
  lookup: Object
});
</script>
<template>
  <table class="w-full table-fixed">
    <thead>
      <tr>
        <th class="pb-3 text-left md:w-2/12" scope="col">
          {{ $t('lookup.partials.dns.card_detail_a.rdtype') }}
        </th>
        <th class="pb-3 text-left md:w-1/12" scope="col">TTL</th>
        <th class="pb-3 text-left" scope="col">
          {{ $t('lookup.partials.dns.card_detail_a.address') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(address, i) in lookup.addresses" :key="i">
        <td>{{ ~address.indexOf(':') ? 'AAAA' : 'A' }}</td>
        <td>{{ lookup.ttl }}</td>
        <td>{{ address }}</td>
      </tr>
    </tbody>
  </table>
</template>
